import React from 'react';
import '../styles/nftList.css';
import centerImage from '../assets/images/inventory/ClaimButton.png';

function NFTList({ nfts, onTransfer, toAddress, actionText }) {
  return (
    <ul className="list">
      {nfts.length > 0 ? (
        nfts.map((nft, index) => (
          <li key={index} className="card">
            {/* Left item image */}
            <div
              className="item-image"
              style={{
                backgroundImage: nft.image ? `url(${nft.image})` : 'none',
              }}
            ></div>
            {/* Center text and right button */}
            <div className="card-content">
              <p className="nft-name">{nft.name}</p>
              <img
                src={centerImage}
                alt="Action Button"
                className="actionButtonImage"
                onClick={() => onTransfer(nft.tokenId, toAddress)}
              />
            </div>
          </li>
        ))
      ) : (
        <p className="nft-none">You currently don’t have any NFTs.</p>
      )}
    </ul>
  );
}

export default NFTList;
